import ActionButton from './ActionButton.vue'

export default ActionButton



// WEBPACK FOOTER //
// ./src/app/components/common/actionButton/index.js